export const UserCard = [
    { span: 7, height: "48px", classes: "marginTop-16" },
    { span: 7, height: "48px", classes: "marginTop-8" },
    { span: 7, height: "48px", classes: "marginTop-8" },
    { span: 7, height: "48px", classes: "marginTop-8" },
]
